import Swal from "sweetalert2";

export default {
    /**
     * Notifications
     */
    notificationSuccess(message) {
        Swal.fire({
            toast: true,
            position: "top-end",
            showConfirmButton: false,
            showCloseButton: true,
            timer: 6000,
            timerProgressBar: true,
            icon: "success",
            title: '<span class="text-xs"> ' + message + " </span>",
        });
    },

    notificationError(message) {
        Swal.fire({
            toast: true,
            position: "top-end",
            showConfirmButton: false,
            showCloseButton: true,
            timer: 6000,
            timerProgressBar: true,
            icon: "error",
            title: '<span class="text-xs"> ' + message + " </span>",
        });
    },

    /**
     * Messages
     */
    messageSuccess(message) {
        Swal.fire({
            timer: 3000,
            timerProgressBar: true,
            icon: "success",
            title: message,
            buttonsStyling: false,
            showCloseButton: true,
            customClass: {
                confirmButton: "btn btn-success btn-lg",
            },
        });
    },

    messageError(message) {
        Swal.fire({
            timer: 3000,
            timerProgressBar: true,
            icon: "error",
            title: message,
            buttonsStyling: false,
            showCloseButton: true,
            customClass: {
                confirmButton: "btn btn-success btn-lg",
            },
        });
    },

    /**
     * Confirmations
     */

    askConfirmation(options) {
        const defaultOptions = {
            title: null,
            text: null,
            icon: "warning",
            showCancelButton: true,
            buttonsStyling: false,
            customClass: {
                confirmButton: "btn btn-success btn-lg",
                cancelButton: "btn btn-light btn-lg ms-2",
            },
            confirmButtonText: "Confirmer",
            cancelButtonText: "Annuler",
        };

        options = {
            ...defaultOptions,
            ...options,
        };

        return Swal.fire(options);
    },
};
